module.exports = __webpack_public_path__ + "static/media/pkm-jas2.cfe78e08.JPG";